import { maskName } from '@/utils'

// 拨号诉求
export const dialIntentEnum = {
  1: '服务咨询',
  2: '投诉建议',
  3: '待购主动提醒'
}
// 实际诉求
export const actualIntentEnum = {
  1: '服务咨询',
  2: '投诉建议',
  3: '待购主动提醒'
}
// 头部的信息
export const headerInfo = [
  {
    label: '出生日期',
    key: 'birthDate'
  },
  {
    label: '健康信息',
    key: 'ucPatientId'
  },
  {
    label: '身份证号',
    key: 'idCard'
  },
  {
    label: '注册号码',
    key: 'phone'
  },
  {
    label: '注册时间',
    key: 'registerTime'
  },
  {
    label: '授权位置',
    key: 'region'
  },
  {
    label: '已关联号码',
    key: 'phoneRelList'
  },
  {
    label: '家庭住址',
    key: 'address'
  }
]
// 量表
export const colScale = [
  {
    title: '推送时间',
    dataIndex: 'sendAt'
  },
  {
    title: '量表',
    dataIndex: 'surveyName'
  },
  {
    title: '填写状态',
    dataIndex: 'statusString',
    key: 'statusString'
  },
  {
    title: '推送人',
    dataIndex: 'sendName',
    slots: {
      customRender: 'sendName'
    }
    // customRender: ({ record, text }) => {
    //   return text || record?.sendPersonName
    // }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    slots: {
      customRender: 'operation'
    },
    width: 120
  }
]
// 全病程管理随访计划
export const ColFollowup = [
  {
    title: '随访计划',
    dataIndex: 'followupPlanName',
    width: 150
  },
  {
    title: '入组来源',
    dataIndex: 'businessType',
    // 业务类型 1-补充诊疗记录id 2-处方编号
    customRender: ({ text }) => ['--', '补充诊疗记录', '处方编号'][text]
  },
  {
    title: '状态',
    dataIndex: 'followupStatus',
    // 0-未开始 1-进行中 2-已完成 3-已终止 4-已超时
    customRender: ({ text }) => ['未开始', '进行中', '已完成', '已终止', '已超时'][text]
  },
  {
    title: '随访开始时间',
    dataIndex: 'firstFollowupPlanDate'
  },
  {
    title: '随访结束时间',
    dataIndex: 'endTime'
  },
  {
    title: '总结段',
    dataIndex: 'totalFollowupTimes'
  },
  {
    title: '目前阶段',
    dataIndex: 'currentFollowupTimes'
  },
  {
    title: '下次随访时间',
    dataIndex: 'nextFollowupTime'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    slots: {
      customRender: 'operation'
    },
    width: 200
  }
]
// 平台服务小结
export const ColSummary = [
  {
    title: '服务小结ID',
    dataIndex: 'chatSummaryId',
    width: 240
  },
  {
    title: '拨号诉求',
    dataIndex: 'dialIntentStr',
    width: 110,
    slots: {
      customRender: 'dialIntentStr'
    }
  },
  {
    title: '实际诉求',
    dataIndex: 'actualIntentStr',
    width: 110,
    slots: {
      customRender: 'actualIntentStr'
    }
  },
  {
    title: '服务时间',
    dataIndex: 'createdAt',
    width: 180
  },
  {
    title: '服务医助',
    dataIndex: 'createByName',
    width: 120
  },
  {
    title: '就诊人姓名',
    dataIndex: 'patientName',
    width: 110,
    customRender: ({ text }) => maskName(text)
  },
  {
    title: '服务详情',
    dataIndex: 'operation',
    key: 'operation',
    width: 120,
    slots: {
      customRender: 'operation'
    }
  },
  {
    title: '关联处方',
    dataIndex: 'parentSns',
    width: 180,
    slots: {
      customRender: 'parentSns'
    }
  },
  {
    title: '小结来源',
    dataIndex: 'workOrderIds',
    width: 350,
    slots: {
      customRender: 'workOrderIds'
    }
  }
]
// 短信
export const ColMessage = [
  {
    title: '发送人',
    dataIndex: 'sendPerson',
    slots: { customRender: 'sendPerson' }
  },
  {
    title: '接收人',
    dataIndex: 'receivePerson',
    slots: { customRender: 'receivePerson' }
  },
  {
    title: '发送时间',
    dataIndex: 'sendTime'
  },
  {
    title: '发送状态',
    dataIndex: 'sendStatus',
    slots: { customRender: 'sendStatus' }
  },
  {
    title: '已读情况',
    dataIndex: 'readStatusDesc'
  },
  {
    title: '发送类型',
    dataIndex: 'sendTypeSnapshot'
  },
  {
    title: '短信详情',
    dataIndex: 'smsInfo',
    width: 300,
    slots: { customRender: 'smsInfo' }
  }
]
// 通话
export const ColCommunication = [
  {
    title: '呼出人',
    dataIndex: 'callerType',
    key: 'callerType',
    align: 'left',
    width: 140,
    slots: {
      customRender: 'callerType'
    }
  },
  {
    title: '接听人',
    dataIndex: 'calleeName',
    key: 'calleeName',
    align: 'left',
    width: 140,
    slots: {
      customRender: 'calleeName'
    }
  },
  {
    title: '拨号诉求',
    dataIndex: 'dialIntentStr',
    width: 110,
    customRender: ({ text }) => text || '--'
  },
  {
    title: '实际诉求',
    dataIndex: 'actualIntentStr',
    width: 110,
    customRender: ({ text }) => text || '--'
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    align: 'left',
    width: 180
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    align: 'left',
    width: 180
  },
  {
    title: '电话时长',
    dataIndex: 'duration',
    key: 'duration',
    align: 'left',
    width: 150,
    slots: {
      customRender: 'duration'
    }
  },
  {
    title: '通话状态',
    dataIndex: 'endStatusDesc',
    key: 'endStatusDesc',
    align: 'left',
    width: 100,
    slots: {
      customRender: 'endStatusDesc'
    }
  },
  {
    title: 'AI小结',
    dataIndex: 'chatSummaryStatus',
    align: 'left',
    width: 100,
    customRender: ({ text }) => {
      const arr = ['生成失败', '已生成', '生成中'] //   0-失败 1-成功 2-生成中
      return arr[text]
    }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 200,
    slots: {
      customRender: 'operate'
    }
  }
]
